import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { remCalc } from "../../utils/helpers";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  btnSave: {
    textTransform: "none",
    minWidth: remCalc(51),
    padding: theme.spacing(1.25, 2),
    lineHeight: "1rem",
    "&.Mui-disabled, &.Mui-disabled:hover": {
      backgroundColor: "#1329FE",
      color: "#fff",
      opacity: "38%"
    }
  },
  btnCancel: {
    color: "#4D4D50",
    minWidth: remCalc(63),
    marginRight: theme.spacing(1),
    padding: theme.spacing(1.25, 2),
    lineHeight: "1rem"
  },
  btnGroup: {
    paddingRight: theme.spacing(5),
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  }
}));

export default function EditDialogActions({
  disabled,
  cancelText = "Cancel",
  confirmText = "Save",
  handleClose = () => {},
  handleClick = () => {},
  className = "",
  section = "",
  cancelDisabled,
  actionButtonId,
  ...props
}) {
  const classes = useStyles();

  return (
    <div className={classes.btnGroup} {...props}>
      <Button
        onClick={handleClose}
        className={classes.btnCancel}
        id="cancel-action"
        data-cy={`${section}-cancel`}
        disabled={cancelDisabled}
      >
        {cancelText}
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={clsx(classes.btnSave, className)}
        onClick={handleClick}
        disabled={disabled}
        data-cy={`${section}-save`}
        id={actionButtonId}
      >
        {confirmText}
      </Button>
    </div>
  );
}
